import { verdictColor, type VerdictType } from "@/mocks/articles";

interface Props {
  verdict: VerdictType;
  size?: "sm" | "md";
}

export default function VerdictBadge({ verdict, size = "sm" }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border font-500 ${
        verdictColor[verdict]
      } ${size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3.5 py-1 text-sm"}`}
    >
      <i className="ri-shield-check-line text-[0.95em]"></i>
      {verdict}
    </span>
  );
}